const configurationLandingEn = {
  configuration_landing: {
    page_title: `Configurations`,
    document_title: `Document`,
    document_description: `Set up fields for your documents`,
    mapping_title: `Mapping`,
    mapping_description: `Automate field mapping rules`,
    export_title: `Export`,
    export_description: `Manage how documents are exported`,
    discrepancy_title: `Discrepancy`,
    discrepancy_description: `Set rules to catch document mismatches`,
    workflow_title: `Workflow`,
    workflow_description: `Manage approval routing and alerts`,
    coding_template_title: `Coding Template`,
    coding_template_description: `Split invoice costs across dimensions by supplier`,
    posting_date_policy_title: `Posting Date Policy`,
    posting_date_policy_description: `Set rules for which date invoices post to your books`,
    peppol_party_registration_title: `Peppol Party Registration`,
    peppol_party_registration_description: `Manage peppol party registration`,
    extraction_configuration_title: `Extraction Configuration`,
    extraction_configuration_description: `Set rules for watermark removal and first-page processing`,
    validation_title: `Validation Configuration`,
    validation_description: `Choose which fields are validated on standardized documents`,
  },
};

export default configurationLandingEn;
